import React from 'react';
import HeroContentContainer from './HeroContentContainer';

export default function HeroSection() {
    return (
        <div className="hero-section">
            <HeroContentContainer />
        </div>
    )
}